import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyBulkOrderComponent } from './lazy-bulk-order/lazy-bulk-order.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'bulkOrder',
        location: () => import('../store/bulk-order-store.module').then(m => m.BulkOrderStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyBulkOrderComponent],
  exports: [LazyBulkOrderComponent],
})
export class BulkOrderExportsModule {}
